import React, { useContext } from 'react'
import styled from 'styled-components'
import { ModalContext } from 'containers/ModalManager'
import { LaunchSketchAlert } from 'containers/modals/LaunchSketchAlert'
import { getParsedItem, setStringifiedItem } from 'utils/localStorage'
import { FlatButton } from 'components/Button/FlatButton'
import {
  StyledDismissableCard,
  Message,
} from 'modules/shares/DetailView/DetailView.styles'
import { linkStyles } from 'styles/global'

const MISSING_FONTS_LOCAL_STORAGE_KEY = 'dismissedMissingFonts'

interface CustomFontsMessageProps {
  userCanContribute: boolean
  shareIdentifier: string
  hasMissingFonts: boolean
}

export const CustomFontsMessage = ({
  userCanContribute,
  shareIdentifier,
  hasMissingFonts,
}: CustomFontsMessageProps) => {
  const { showModal } = useContext(ModalContext)

  const dismissedWarningShareIds: string[] =
    getParsedItem(MISSING_FONTS_LOCAL_STORAGE_KEY) || []
  const shouldShowFontsWarning = !dismissedWarningShareIds.includes(
    shareIdentifier
  )

  const handleDismiss = () => {
    const currentValue = [...dismissedWarningShareIds, shareIdentifier]
    setStringifiedItem(MISSING_FONTS_LOCAL_STORAGE_KEY, currentValue)
  }

  const handleOpen = (e: React.MouseEvent) => {
    e.preventDefault()

    showModal(LaunchSketchAlert, {
      shareId: shareIdentifier,
      action: 'openInSketch',
    })
  }

  return (
    <StyledDismissableCard
      title="Document is missing custom fonts"
      onDismiss={handleDismiss}
      isVisible={hasMissingFonts && shouldShowFontsWarning}>
      {userCanContribute ? (
        <Message>
          To embed missing fonts,{' '}
          <ButtonLink onClick={handleOpen}>open the document</ButtonLink> and
          select File &gt; Document Settings &gt; Fonts
        </Message>
      ) : (
        <Message>
          For an accurate preview, ask the document&apos;s author to embed the
          fonts.
        </Message>
      )}
    </StyledDismissableCard>
  )
}
const ButtonLink = styled(FlatButton)`
  padding: 0;
  ${linkStyles}
`
